// extracted by mini-css-extract-plugin
export default {"mobileContainer":"CugBadge_mobileContainer__Hay2K","cugBadge":"CugBadge_cugBadge__6dt5W"};